import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, Button, Dropdown } from 'react-bootstrap';
import domainName from '../../domainName';
import { COLORS } from '../../colorTheme/colorTheme';
import './community.css';
import { useTranslation } from 'react-i18next';

const CommentModal = ({ post, onClose, userId, isOwner, onEdit, onDelete, onLike, onCommentAdded }) => {
    const [commentText, setCommentText] = useState('');
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [localPost, setLocalPost] = useState(post);
    const [t] = useTranslation('global');

    // update local post when new post props come in
    useEffect(() => {
        if (post) {
            setLocalPost(post);
            fetchComments(post._id);
        }
    }, [post]);

    const fetchComments = async (postId) => {
        try {
            const res = await domainName.serverAPICall(
                domainName.debugAPI + '/community/listAllCommentByPostId',
                'POST',
                JSON.stringify({ PostId: postId })
            );
            const json = await domainName.handleServerAPICallErrors(res);
            setComments(json.Data || []);
        } catch (err) {
            console.error('Error loading comments', err);
        }
    };

    const handleSubmit = async () => {
        if (!commentText.trim()) {
            alert(t('error.Comment cannot be empty'));
            return;
        }

        setLoading(true);

        try {
            const res = await domainName.serverAPICall(
                domainName.debugAPI + '/community/userCreateComment',
                'POST',
                JSON.stringify({
                    PostId: localPost._id,
                    UserId: userId,
                    PostUserId: localPost.author,
                    CommentText: commentText,
                })
            );
            const json = await domainName.handleServerAPICallErrors(res);

            if (json.ReturnCode === 200) {
                setCommentText('');
                await fetchComments(localPost._id);

                setLocalPost(prev => ({
                    ...prev,
                    Totalcomments: (prev.Totalcomments || 0) + 1
                }));

                if (onCommentAdded) onCommentAdded();

            } else {
                alert(t('error.Comment failed, please try it again later.'));
            }
        } catch (err) {
            console.error('Submit comment failed', err);
        }

        setLoading(false);
    };

    const handleLikeClick = async () => {
        await onLike(localPost);
        // manually update like UI in modal
        setLocalPost((prev) => ({
            ...prev,
            IsLike: !prev.IsLike,
            TotalLikes: prev.TotalLikes + (prev.IsLike ? -1 : 1),
        }));
    };

    return (
        <Modal show onHide={onClose} size="lg" fade={false}>
            <div style={{ height: 'auto', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                <Modal.Header closeButton>
                    <Modal.Title>{localPost.UserName}</Modal.Title>
                </Modal.Header>
                <Modal.Body
                    style={{
                        overflowY: 'auto',
                        flexGrow: 1,
                        paddingRight: '15px',
                        marginBottom: '1rem',
                    }}
                >
                    {/* User Info */}
                    <Row>
                        <Col xs="auto">
                            <img
                                src={localPost.UserImageDisplay}
                                alt="User"
                                style={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '50%',
                                    objectFit: 'cover',
                                }}
                            />
                        </Col>
                        <Col>
                            <div className="ms-1">
                                <div style={{ fontWeight: 'bold' }}>{localPost.UserName}</div>
                                <div style={{ color: COLORS.gray }}>{localPost.CreatedAtDisplay}</div>
                            </div>
                        </Col>
                    </Row>

                    {/* Post content */}
                    <Row className="mt-3">
                        <Col>
                            <div
                                dangerouslySetInnerHTML={{ __html: localPost.title }}
                                style={{ overflowWrap: 'break-word' }}
                            />
                        </Col>
                    </Row>

                    {/* Images */}
                    {localPost.ListingImageDisplay?.map((img, idx) => (
                        <Row key={idx} className="my-3">
                            <Col>
                                <img
                                    src={img}
                                    alt="post-img"
                                    className="img-fluid"
                                    style={{
                                        width: '100%',
                                        maxHeight: '300px',
                                        objectFit: 'contain',
                                        borderRadius: '10px',
                                    }}
                                />
                            </Col>
                        </Row>
                    ))}

                    {/* Like / Comment / Edit */}
                    <Row className="mt-3">
                        <Col xs={4} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', cursor: 'pointer', overflow: 'hidden', whiteSpace: 'nowrap', flexShrink: 1 }} onClick={handleLikeClick}>
                            <span style={{ marginLeft: '10px', color: COLORS.orange }}>
                                {localPost.IsLike ? 'Unlike' : 'Like'} ({localPost.TotalLikes ?? 0})
                            </span>
                        </Col>

                        <Col xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', overflow: 'hidden', whiteSpace: 'nowrap', flexShrink: 1 }}>
                            <span style={{ marginLeft: '10px', color: COLORS.orange }}>
                                Comment ({localPost.Totalcomments ?? 0})
                            </span>
                        </Col>
                        {isOwner && (
                            <Col xs={4} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div className="dropdown">
                                    {/* Category dropdown */}
                                    <div
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            paddingTop: '2%',
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            <img
                                                src={require('../../img/icons/more.png')}
                                                style={{ width: '20px', height: '20px', alignSelf: 'center', marginRight: '5%' }}
                                                alt="More icon"
                                                fluid
                                            />
                                        </div>
                                    </div>

                                    <ul className="dropdown-menu" style={{ position: 'absolute', top: '100%', left: 0, zIndex: 1000 }}>
                                        <li>
                                            <a
                                                className={`dropdown-item`}
                                                href="#"
                                                onClick={onEdit}
                                            >
                                                Edit
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className={`dropdown-item`}
                                                href="#"
                                                onClick={onDelete}
                                            >
                                                Delete
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                        )}
                    </Row>

                    {/* Comments List */}
                    {comments.map((comment, idx) => (
                        <div key={idx}>
                            {/* Divider line */}
                            <Row>
                                <Col>
                                    <div
                                        style={{
                                            borderBottom: `1px solid ${COLORS.lightGray1}`,
                                            marginTop: '10px',
                                            marginBottom: '10px',
                                        }}
                                    ></div>
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col xs="auto">
                                    <img
                                        src={comment.author.ImageDisplay}
                                        alt="avatar"
                                        style={{
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </Col>

                                <Col>
                                    {/* Name & Time */}
                                    <div style={{ fontWeight: 'bold' }}>{comment.author.Name}</div>
                                    <div style={{ color: COLORS.gray, fontSize: '14px' }}>{comment.DisplayCreatedAt}</div>
                                </Col>
                            </Row>

                            <Row className="mt-2">
                                <Col>
                                    {/* Comment content */}
                                    <div
                                        style={{
                                            marginTop: '8px',
                                            backgroundColor: 'transparent',
                                            borderRadius: '5px',
                                            paddingLeft: '0.5em',
                                            wordWrap: 'break-word',
                                        }}
                                    >
                                        {comment.comment}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    ))}
                </Modal.Body>

                {/* Submit comment */}
                <Modal.Footer style={{ gap: '1rem' }}>
                    <textarea
                        value={commentText}
                        onChange={(e) => setCommentText(e.target.value)}
                        placeholder={t('community.Write your comment')}
                        style={{
                            flex: 1,
                            height: '48px',
                            borderColor: COLORS.lightGray1,
                            borderWidth: 1,
                            borderRadius: 5,
                            padding: '10px',
                            fontSize: '16px',
                            resize: 'none',
                        }}
                    />
                    <Button
                        onClick={handleSubmit}
                        disabled={loading}
                        style={{
                            backgroundColor: COLORS.orange,
                            borderColor: COLORS.orange,
                            height: '48px',
                            fontSize: '16px',
                        }}
                    >
                        + {t('community.Comment')}
                    </Button>
                </Modal.Footer>
            </div>
        </Modal>

    );
};

export default CommentModal;
